import { useQuery } from '@tanstack/react-query';
import { ProjectFolder, OrgId } from '@clef/shared/types';
import ProjectFolderAPI from '@/api/project_folder_api';
import { ApiErrorType } from '@/api/base_api';
import { useTypedSelector } from '@/hooks/useTypedSelector';

export const projectFolderQueryKeys = {
  all: ['projectFolders'] as const,
  list: (orgId: OrgId, parentFolderId?: number | null) =>
    [orgId, ...projectFolderQueryKeys.all, 'list', { parentFolderId }] as const,
  detail: (id: number) => [...projectFolderQueryKeys.all, 'detail', id] as const,
};

export const useGetProjectFoldersQuery = (parentFolderId?: number | null) => {
  const orgId = useTypedSelector(state => state.login.user?.orgId);
  return useQuery<ProjectFolder[], ApiErrorType>({
    queryKey: projectFolderQueryKeys.list(orgId ?? -1, parentFolderId),
    queryFn: async () => {
      const res = await ProjectFolderAPI.list(parentFolderId);
      return res.data;
    },
    enabled: !!orgId,
  });
};

export const useGetAllProjectFoldersQuery = () => {
  const orgId = useTypedSelector(state => state.login.user?.orgId);
  return useQuery<ProjectFolder[], ApiErrorType>({
    queryKey: projectFolderQueryKeys.list(orgId ?? -1),
    queryFn: async () => {
      const res = await ProjectFolderAPI.list();
      return res.data;
    },
    enabled: !!orgId,
  });
};

export const useGetProjectFolderQuery = (id: number) => {
  return useQuery<ProjectFolder, ApiErrorType>({
    queryKey: projectFolderQueryKeys.detail(id),
    queryFn: async () => {
      const res = await ProjectFolderAPI.getById(id);
      return res.data;
    },
    enabled: !!id,
  });
};
